module.exports = __webpack_public_path__ + "static/assets/eaeb23f373203785501e12ece22ebe9e.png";